import merge from "lodash/merge";
import { ChartCandle, FillSeriesOptions } from "../chart.typings";
import BaseChartSeries from "./baseSeries";
import { FillSeries as CustomFillSeries } from "../customSeries/fillSeries/fill-series";
import { defaultOptions } from '../customSeries/fillSeries/options'
import { FillData } from "../customSeries/fillSeries/data";
import { IndicatorOutput_OutputStyle } from "../../../proto/generated/indicator";
import { evaluateExpression } from "../../../util/safeExpressionEval";

class FillSeries extends BaseChartSeries<FillData, FillSeriesOptions> {

    customPaneView?: CustomFillSeries<FillData>

    init() {
        this.customPaneView = new CustomFillSeries();
    }

    addSeriesToChart() {
        return this.chart.chartApi.addCustomSeries(this.customPaneView!, this.seriesOptions)
    }
    
    getDefaultOptions(): FillSeriesOptions {
        return merge(defaultOptions, this.options)
    }

    generateSeriesData(data: ChartCandle[], metadata: Record<string, any> = {}): FillData[] {
    
            const result: FillData[] = [];
            const open: number[] = new Array(data.length);
            const close: number[] = new Array(data.length);
            const series: number[] = new Array(data.length);
            const seriesA: number[] = new Array(data.length);
            const seriesB: number[] = new Array(data.length);

            const {color: seriesColor} = this.seriesApi.options()
    
    
            const {color: metaColor} = metadata;
            const {color: configColor} = this.config;
            // Some scripts send the hex code without the leading '#'.
            const isColorHexCode = metaColor && RegExp(/^#?[0-9a-fA-F]{6}([0-9a-fA-F]{2})?$/).test(metaColor)
            const color = isColorHexCode ? configColor : metaColor;
            if (isColorHexCode && seriesColor !== color) {
                this.seriesApi.applyOptions({color})
            }
    
            data.forEach((candle, index) => {
                if (candle.fillHigh === undefined || candle.fillLow === undefined) return;
                let candleColor = color;

                if (isNaN(candle.fillHigh as number) && isNaN(candle.fillLow) && this.config.style === IndicatorOutput_OutputStyle.WITH_BREAKS) {
                    candleColor = "transparent"
                } else if (!isColorHexCode && candleColor) {
                    open[index] = candle.open;
                    close[index] = candle.close;
                    series[index] = candle.series || 0
                    seriesA[index] = candle.fillHigh as number
                    seriesB[index] = candle.fillLow as number
                    // Scripts compare the two fill edges as seriesA[i] / seriesB[i].
                    candleColor = evaluateExpression<string>(color, { open, close, series, seriesA, seriesB, candle, index, i: index })
                }
    

                result.push({
                    ...candle,
                    high: candle.fillHigh,
                    low: candle.fillLow,
                    color: candleColor && (candleColor == "transparent" || !isColorHexCode) ? candleColor : undefined
                })
    
            })
    
            return result;
        }

}

export default FillSeries;